import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  scrollableItems: {
    display: 'flex',
    flexDirection: 'column',
  },
  autocompletePopper: {
    width: '100% !important',
    boxSizing: 'border-box',
    paddingRight: '48px',
    marginTop: '10px',
  },
  searchIcon: {
    color: theme.evPalette.charcoal[500],
    margin: '0 10px',
    '&:has(~ input:focus)': {
      color: theme.evPalette.charcoal[900],
    },
  },
  mainContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    position: 'relative',
  },
  addressSearchContainer: {
    width: '100%',
    backgroundColor: theme.evPalette.salt[100],
    borderBottom: `1px solid ${theme.evPalette.charcoal[200]}`,
    display: 'flex',
    minHeight: '78px',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (min-width: 640px)': {
      padding: '15px 24px 15px 10px',
      flexWrap: 'nowrap',
    },
  },
  addressSearch: {
    width: '100%',
    alignItems: 'center',
    padding: '15px 24px',
    justifyContent: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'nowrap',
    '@media (min-width: 640px)': {
      padding: '0px 15px',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      gap: '20px',
      flexWrap: 'wrap',
    },
  },
  legacyRedirectionLinkContainer: {
    display: 'flex',
    minWidth: 'fit-content',
    alignItems: 'center',
  },
  legacyRedirectionLink: {
    fontSize: '12px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  countrySelect: {
    width: '85px',
    height: '44px',
    borderStartStartRadius: 0,
    borderEndStartRadius: 0,
    '& fieldset': {
      borderLeftWidth: '0',
    },
    '@media (min-width: 640px)': {
      width: '200px',
      borderRadius: '4px',
      '& fieldset': {
        borderLeftWidth: '1px',
      },
    },
  },
  addressSearchTextContainer: {
    flex: '1 1 auto',
    '@media (min-width: 640px)': {
      flex: '0',
    },
  },
  autocompleteRoot: { width: '100%' },
  typeaheadSearchInput: {
    alignItems: 'center',
    height: '44px',
    padding: 0,
    justifyContent: 'space-around',
    flex: '1 1 auto',
    borderStartEndRadius: 0,
    borderEndEndRadius: 0,
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      width: '370px',
    },
    '& >.myev-MuiAutocomplete-endAdornment': {
      marginRight: '15px',
      color: theme.evPalette.charcoal[600],
      position: 'static',
    },
  },
  typeaheadSearchInputfocused: {
    backgroundColor: theme.evPalette.charcoal[100],
  },
  uploadBlueprintButtonContainer: {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'nowrap',
    '@media (min-width: 640px)': {
      gap: '20px',
    },
  },
  uploadBlueprintButton: {
    height: '44px',
    '&>span': {
      whiteSpace: 'nowrap',
    },
  },
  selectionContainer: {
    flex: '1 1 auto',
    width: '100%',
    '&.unauthorised': {
      '@media (max-width: 640px)': {
        flexDirection: 'column',
      },
    },
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: '420px',
    '@media (min-width: 640px)': {
      height: '100%',
    },
  },
  sideContainer: {
    position: 'relative',
    backgroundColor: theme.evPalette.salt[100],
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: '460px',
  },
  productContainer: {
    position: 'relative',
    height: '66px',
    background: 'green',
    borderBottom: '1px solid',
  },
  measurementInstructionsContainer: {
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)',
    zIndex: 2,
    padding: '10px 26px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
  },
  measurementInstructionsSelect: {
    flex: 1,
    width: 0,
    color: '#5F7286',
  },
  estimationContainer: {
    flexDirection: 'column',
    borderTop: `1px solid ${theme.evPalette.charcoal[500]}`,
    padding: '12px 22px',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    rowGap: '8px',
    '&>*': {
      padding: '10px 16px',
    },
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  searchPromptText: {
    width: '80%',
    textAlign: 'left',
    color: theme.evPalette.charcoal[800],
    '@media (min-width: 640px)': {
      textAlign: 'center',
    },
  },
  searchContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    backgroundColor: theme.evPalette.salt[100],
    flexWrap: 'nowrap',
    width: '100%',
    position: 'relative',
    overflowY: 'auto',
    bottom: 0,
    zIndex: 101,
    padding: '24px 0',
    '@media (min-width: 640px)': {
      flexWrap: 'wrap',
      position: 'static',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      flex: 1,
      height: 'auto',
      alignContent: 'flex-start',
      padding: '0px',
      width: '420px',
    },
  },

  searchPromptContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    margin: '20px 20px 10px 20px',
    padding: '24px',
    '@media (min-width: 640px)': {
      margin: '0 auto',
      flexDirection: 'column',
      gap: '24px',
      padding: '0 42.5px',
      marginTop: '24px',
    },
  },
  searchPromptImg: {
    marginRight: '24px',
    width: '70px',
    height: '60px',
    '@media (min-width: 640px)': {
      height: '120px',
      width: '140px',
    },
  },
  productPanelMobile: {
    width: '100%',
    position: 'absolute',
    backgroundColor: theme.evPalette.salt[100],
    minHeight: 0,
    display: 'flex',
    paddingTop: '10px',
    flexDirection: 'column',
    transitionDuration: '415ms',
    transition: 'all 500ms linear',
  },
  roundedTop: { borderRadius: '10px 10px 0px 0px' },
  productPanelMobileClosed: {
    top: '94%',
    height: '6%',
    overflow: 'hidden',
    zIndex: 99,
  },
  productPanelMobileOpen: {
    top: '0%',
    height: '100%',
    zIndex: 199,
  },
  toggleMapButton: {
    color: theme.evPalette.ocean[600],
    textTransform: 'none',
    padding: '0',
    height: '40px',
    '& .myev-MuiButton-label': {
      height: '40px',
    },
  },
  toggleMapArrow: { margin: '14px' },
  searchTabs: {
    backgroundColor: theme.evPalette.salt[100],
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    minHeight: '72px',
    '& .myev-MuiTabs-flexContainer': { justifyContent: 'space-evenly' },
  },
  tabHeading: {
    textTransform: 'none',
    fontWeight: 600,
    color: theme.evPalette.charcoal[700],
    opacity: 1,
    padding: '26px 16px',
    '&.Mui-selected': { color: theme.evPalette.charcoal[900] },
    '&.myev-MuiButtonBase-root': { maxHeight: '72px' },
  },
  failedToLoadContainer: {
    position: 'absolute',
    top: '72%',
    backgroundColor: theme.evPalette.salt[100],
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '10px 24px',
    alignItems: 'unset',
    '@media (min-width: 640px)': {
      position: 'unset',
      padding: '24px',
      gap: '24px',
      alignItems: 'flex-start',
    },
  },
  failedToLoadHeading: {
    color: theme.evPalette.ocean[700],
    fontFamily: 'Noto Sans',
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: '54px',
  },
  retryLabel: {
    columnGap: '8px',
  },
  bannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center',
    backgroundColor: theme.evPalette.salt[100],
    minWidth: '420px',
    height: 'fit-content !important',
    borderBottom: 'none',
    '@media (min-width: 640px)': {
      borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    },
  },

  srsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'center',
    backgroundColor: theme.evPalette.salt[100],
    width: '100%',
    height: 'fit-content !important',
    borderBottom: 'none',
    '@media (min-width: 640px)': {
      borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    },
  },
  srsalert: {
    borderRadius: '0px',
    backgroundColor: '#E2F7DA',
    borderBottom: `1px solid ${theme.evPalette.lime[700]}`,
    '@media (min-width: 640px)': {
      padding: '8px 16px 8px 16px',
    },
  },
  srsalertMsg: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.evPalette.charcoal[900],
    gap: '8px',
    fontSize: '14px',
    '&>.message': {
      fontWeight: 400,
      lineHeight: '18px',
      fontSize: '14px',
    },
    '@media (min-width: 640px)': {
      gap: '16px',
      '&>.message': {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '24px',
      },
    },
  },

  srssuccessAlertIcon: { '& svg': { color: theme.evPalette.lime[700] }, alignItems: 'center' },
  closeBtn: { '& svg': { color: theme.evPalette.lime[700] }, alignItems: 'center', marginRight: '0px' },
  srsalertMsgText: {
    gap: '4px',
    fontSize: '14px',
    display: 'flex',
    lineHeight: '18px',
    alignItems: 'center',
    color: theme.evPalette.charcoal[900],
    '@media (max-width: 1024px)': {
      flexWrap: 'wrap',
    },
  },

  estimationAndSubmissionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  alertContainer: {
    backgroundColor: theme.evPalette.mango[100],
    height: 'fit-content',
    width: '100%',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  alertMainContainer: {
    padding: '0px',
    width: '100%',
    '@media (min-width: 640px)': {
      borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
      minWidth: '420px',
      padding: '24px',
    },
  },
  orderResolvedMessage: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '27px',
    color: theme.evPalette.charcoal[900],
    '& a': {
      color: theme.evPalette.ocean[700],
      textDecoration: 'none',
    },
  },
  warningAlertIcon: { '& svg': { color: theme.evPalette.mango[700] } },

  loginContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
  },
  loginBtnContainer: {
    display: 'flex',
    width: '100%',
    gap: '16px',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  loginButton: {
    height: '44px',
  },
  searchOpenPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.evPalette.salt[100],
    gap: '24px',
    padding: '24px',
    height: '100%',
    width: '100%',
    '@media (min-width: 640px)': {
      maxWidth: '420px',
    },
  },
  mapProviderToggle: {
    position: 'static !important',
    width: 'fit-content',
    zIndex: '1 !important',
  },
  prePanelScrollableSection: {
    minHeight: '100%',
    justifyContent: 'center',
  },
}));
